export default "__VITE_ASSET__CzYs9UFh__"